// removed by extract-text-webpack-plugin
module.exports = {"container":"onfido-sdk-ui-CustomFileInput-container","input":"onfido-sdk-ui-CustomFileInput-input"};


//////////////////
// WEBPACK FOOTER
// ./components/CustomFileInput/style.css
// module id = 373
// module chunks = 1